import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSuccessfulCreateSnackbar, useFailedCreateSnackbar, LoadingIndicator } from '../../../../Components/CoreLib/library';
import { HourlyLineItemDto } from '../../../../dtos';
import { useCreateHourlyLineItemMutation, useLazyGetOrderByIdQuery, useLazyGetQuoteByIdQuery } from '../../../../store/generated/generatedApi';
import { HourlyLineItemForm } from '../../../../Components/Forms/QuoteForm/LineItemForms/HourlyLineItem/HourlyLineItemForm';
import { DEFAULT_HAULING_LINE_ITEM } from '../../../../Components/Forms/QuoteForm';

export const AddHourlyLineItemView: FC = () => {
    const { quoteId, jobId, orderId } = useParams();
    const navigate = useNavigate();
    const [getQuote, { data: quote, isLoading: isQuoteLoading }] = useLazyGetQuoteByIdQuery();
    const [createHourlyLineItem, { isError, isSuccess, reset }] = useCreateHourlyLineItemMutation();
    const [getOrder, { data: order, isLoading: isOrderLoading }] = useLazyGetOrderByIdQuery();

    useEffect(() => {
        if (quoteId && !quote) {
            getQuote({ id: quoteId! });
        }
    }, [getQuote, quote, quoteId]);

    useEffect(() => {
        if (orderId && !order) {
            getOrder({ id: orderId! });
        }
    }, [getOrder, order, orderId]);

    useSuccessfulCreateSnackbar('Hourly Line Item', isSuccess, () => {
        if (orderId || jobId) {
            navigate(`/job/${jobId}/order/${order?.id ?? 'create'}`);
        } else if (quoteId) {
            navigate(`/quote/${quoteId}/lineItems`);
        } else {
            navigate(`/quotes`);
        }
    });
    useFailedCreateSnackbar('hourly line item', isError, reset)

    const handleSave = (values: HourlyLineItemDto) => {
        createHourlyLineItem(values);
    };

    const handleCancel = () => {
        if (orderId || jobId) {
            navigate(`/job/${jobId}/order/${order?.id ?? 'create'}`);
        } else if (quoteId) {
            navigate(`/quote/${quoteId}/lineItems`)
        } else {
            navigate('/quotes');
        }
    };

    if (isQuoteLoading || isOrderLoading || quote === undefined) {
        return <LoadingIndicator />;
    }

    return <HourlyLineItemForm save={handleSave} cancel={handleCancel} quote={quote} order={order} initValues={DEFAULT_HAULING_LINE_ITEM} />;
};
